import User from "../../data/data-class/sidebarClass";
import axiosInstance from "../../services/axios";
import ViaqTryCatch from "../../services/GlobalTryCatch";

export default class siderepository {
    static async getusername() {
        // const user_data = await postRequestWithToken("/dashboard/user");
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/dashboard/user")
            });
        const code = response.statusCode;
        // const res = response.response;
        const message = response.message;
        let userObject = null;

        if (response.success) {
            const user = response.data;
            userObject = new User(
                user.name,
                user.number.replace("+98", "0"),
                user.access,
                user.password,
                user.links
            );
        }

        return {
            user: userObject,
            code,
            message,
            // res,
        };
    }

    static async edit(data) {
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/dashboard/edit-profile", data)
            });
        const code = response.statusCode;
        const massage = response.message;
        return {
            code,
            massage,
        };
    }

    static async LogOut(data) {
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/dashboard/logout", data)
            });
        const code = response.statusCode;
        const massage = response.message;
        return {
            code,
            massage,
        };
    }
}
